import type { RootState } from '@app/store';
import { MENU_SIDEBAR_STATE } from '@app/store';

export const selectMenuSidebarState = (state: RootState) =>
  state[MENU_SIDEBAR_STATE].menuSidebarState;
